<h2 mat-dialog-title>
	{{ data.title || 'Please Confirm' }}
</h2>
<div mat-dialog-content>
	<p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="false">Cancel</button>
	<button mat-stroked-button type="button" color="primary" [mat-dialog-close]="true">
		Confirm
	</button>
</div>
